import React from 'react';
import filterInputFactory from './FilterInputFactory';

export default class VariableFilters extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {}
        }
    }

    componentDidMount() {
        if (this.props.form) {
            this.setState({form: this.props.form});
        }
    }

    componentWillReceiveProps(props) {
        if (props.form) {
            this.setState({form: props.form});
        }
    }

    variableInnerFilters(filters, onlyActive, parentIndex = 0) {
        return filters.map((item, index) => {
            if (!onlyActive || this.state.form.hasOwnProperty(item.name)) {
                return (
                    <div className="col-md-4" key={`${parentIndex}-${index}-${onlyActive}`}>
                        {filterInputFactory(item, (val) => this.props.handleChange(item.name, val), this.state.form[item.name])}
                    </div>
                );
            }
            return null;
        });
    }

    render() {
        return (
            <div>
                {this.props.searchFilters.map((item, index) => {
                    return (
                        <div className="row" key={index}>
                            <div className="col-12">
                                {!this.props.onlyActive ? (
                                    <p>{item.name}</p>
                                ) : null}
                                <div className="row">
                                    {this.variableInnerFilters(item.filters, this.props.onlyActive, index)}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}